import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import moment from 'moment';

Snappy.Component.EscListViewFixture = class EscListViewFixture extends Snappy.BaseComponent {
    static get tagName() {
        return 'esc-list-view-fixture';
    }
    constructor(element) {
        super(element);
    }

    render() {
        let wrapper = $(".esc-list-view-fixture");
        $(document).ready(function () {
            escListViewFixture.init(wrapper);
        });

        var escListViewFixture = function () {

            var _init = function (ref) {
                setCountdownTimer(ref);
            },
                setCountdownTimer = function (ref) {
                    let _date = $(ref).find('.phCountDownTimer')[0];
                    // Set the date we're counting down to
                    let countDownDate = moment.utc($(_date).attr('datetime')).toDate();
                    var dateTime = countDownDate.getTime();
                    // Update the count down every 1 second
                    var x = window.setInterval(function () {
                        // Get today's date and time
                        var now = new Date().getTime();
                        // Find the distance between now and the count down date
                        var distance = dateTime - now;
                        // Time calculations for days, hours, minutes and seconds
                        var days = ("0" + Math.floor(distance / (1000 * 60 * 60 * 24))).slice(-2);
                        var hours = ("0" + Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).slice(-2);
                        var minutes = ("0" + Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).slice(-2);
                        var seconds = ("0" + Math.floor((distance % (1000 * 60)) / 1000)).slice(-2);
                        $(_date).html(`<div class="col-sm-12">
                                            <div class="col-sm-3">
                                                <h4 class="fixture-timer">
                                                    ${days} <span class="timer_interval">:</span>
                                                </h4>
                                                <h4 class="time-details">DAYS</h4>
                                            </div>
                                            <div class="col-sm-3">
                                                <h4 class="fixture-timer">
                                                    ${hours} <span class="timer_interval">:</span>
                                                </h4>
                                                <h4 class="time-details"> HOURS</h4>
                                            </div>
                                            <div class="col-sm-3">
                                                <h4 class="fixture-timer">
                                                    ${minutes} <span class="timer_interval">:</span>
                                                </h4>
                                                <h4 class="time-details">MINS</h4>
                                            </div>
                                            <div class="col-sm-3">
                                                <h4 class="fixture-timer">
                                                    ${seconds} <span class="timer_interval"></span>
                                                </h4>
                                                <h4 class="time-details">SECONDS</h4>
                                            </div>
                                        </div>`);
                        // If the count down is finished, write some text
                        if (distance < 0) {
                            //console.log('clear');
                            clearInterval(x);
                            $(_date).html("");
                        }
                    }, 1000);
                };
            return {
                init: _init
            };
        }();
    };
}



// WEBPACK FOOTER //
// ./components/esc-redesign/scripts/esc-list-view-fixture.js